import React, { useEffect, useState } from "react";
import { selectUser, userActions } from "Features/user";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { MainHeader } from "Widgets/main_header";
import { Menu } from "antd";
import dayjs from "dayjs";
import "./main.page.scss";

export const MainPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const user = useSelector(selectUser.data);
	const [current, setCurrent] = useState("");
	const currentPage = location.pathname.split("/")[2];
	const [menuItems, setMenuItems] = useState([]);
	const [age, setAge] = useState(0);

	useEffect(() => {
		if (!user?.score || !user?.country || !user?.rating) dispatch(userActions.get());

		initUserAge();
	}, []);
	function initUserAge() {
		const currentDate = dayjs();
		const age = dayjs(currentDate).diff(user?.birthday, "years");
		setAge(age);
	}
	useEffect(() => {
		initMenuItems();
	}, [age]);

	function initMenuItems() {
		const items = [];

		items.push({
			key: "p-history",
			label: "Payment history",
		});
		if (age >= 18) {
			items.push({
				key: "withdraw",
				label: "Withdraw",
			});
		}
		items.push({
			key: "about",
			label: "About application",
		});
		setMenuItems(items);
	}

	function onSelectItem(e) {
		setCurrent(e.key);
		navigate(e.key);
	}

	useEffect(() => {
		menuController(currentPage);
	}, [currentPage]);

	function menuController(currentPage) {
		if (currentPage === "withdraw" && age < 18) {
			onSelectItem({ key: "about" });
			return;
		}
		if (current !== currentPage) {
			setCurrent(currentPage);
		}
		if (!currentPage) {
			onSelectItem({ key: "withdraw" });
		}
	}

	return (
		<div className="main-page">
			<MainHeader />
			<div className="main-page__content">
				<div className="main-page__menu">
					<Menu items={menuItems} onClick={onSelectItem} selectedKeys={[current]} />
				</div>
				<div className="main-page__item">
					<Outlet />
				</div>
			</div>
		</div>
	);
};
